if (!customElements.get('black-friday-products')) {
    class BlackFridayProducts extends HTMLElement {
        constructor() {
            super();

            this.bundles = this.querySelectorAll('.card-product-4__bundles li');
            this.symbol = this.getAttribute('data-price-symbol');
            this.initEvent();

            console.log('bundle:', this.bundles)
        }



        /**
         * @param {HTMLElement} checkBox 
         * @param {HTMLElement} quantityInput 
         */
        update(checkBox, quantityInput) {
            const bundleElement = checkBox.closest('li');
            const cardProduct = bundleElement.closest('.product-card-container');
            const bundleVariantId = bundleElement.getAttribute('data-bundle-variant-id');
            const buyButton = cardProduct.querySelector('buy-now-button');
            const addButton = cardProduct.querySelector('add-cart-button');
            let ids = buyButton.getAttribute('data-variant-id').split(',');
            let quantityList = buyButton.getAttribute('data-quantity').split(',');
            if (checkBox.checked) {
                bundleElement.classList.add('active');
                const findIndex = ids.findIndex((id) => id == bundleVariantId);
                if (findIndex <= -1) {
                    // add id, quantity
                    ids.push(bundleVariantId);
                    quantityList.push(quantityInput.value > 1 ? quantityInput.value : 1);
                } else {
                    // update quantity
                    quantityList[findIndex] = quantityInput.value > 1 ? quantityInput.value : 1;
                }
            } else {
                const findIndex = ids.findIndex((id) => id == bundleVariantId);
                if (findIndex > -1) {
                    // remove id, quantity
                    ids.splice(findIndex, 1);
                    quantityList.splice(findIndex, 1);
                }
                bundleElement.classList.remove('active');
            }
            buyButton.setAttribute('data-variant-id', ids.join(','));
            buyButton.setAttribute('data-quantity', quantityList.join(','));
            addButton.setAttribute('data-variant-id', ids.join(','));
            addButton.setAttribute('data-quantity', quantityList.join(','));

            // Update bundle price 
            const bundlePriceElement = bundleElement.querySelector('[data-bundle-price]');
            const bundleComparePriceElement = bundleElement.querySelector('[data-bundle-compare-price]');
            if (bundlePriceElement && bundleComparePriceElement) {
                const bundlePrice = Number(bundlePriceElement.getAttribute('data-bundle-price'));
                const bundleComparePrice = Number(bundleComparePriceElement.getAttribute('data-bundle-compare-price'));
                const quantity = bundleElement.querySelector('[data-quantity-variant-id]').value;
                const finalPrice = quantity * bundlePrice;
                const finalComparePrice = quantity * bundleComparePrice;
                bundlePriceElement.innerHTML = this.formatMoney(finalPrice);
                bundleComparePriceElement.innerHTML = finalPrice < finalComparePrice
                    ? this.formatMoney(finalComparePrice)
                    : '';

                // this.renderMainPrice(cardProduct);
            }
        }

        /**
         * @param {HTMLElement} cardProduct 
         */
        renderMainPrice(cardProduct) {
            const priceElement = cardProduct.querySelector('[data-price]');
            const comparePriceElement = cardProduct.querySelector('[data-compare-price]');
            if (priceElement && comparePriceElement) {
                const price = Number(priceElement.getAttribute('data-price'));
                const comparePrice = Number(comparePriceElement.getAttribute('data-compare-price'));

                let finalPrice = price;
                let finalComparePrice = comparePrice;
                for (const bundle of cardProduct.querySelectorAll('.card-product-4__bundle')) {
                    const isChecked = bundle.querySelector('[type="checkbox"]').checked;
                    if (isChecked) {
                        const bundlePrice = Number(bundle.querySelector('[data-bundle-price]').getAttribute('data-bundle-price'));
                        const bundleComparePrice = Number(bundle.querySelector('[data-bundle-compare-price]').getAttribute('data-bundle-compare-price'));
                        const quantity = bundle.querySelector('[data-quantity-variant-id]').value;
                        finalPrice += (quantity * bundlePrice);
                        finalComparePrice += (quantity * bundleComparePrice);
                    }
                }
                priceElement.innerHTML = this.formatMoney(finalPrice);
                comparePriceElement.innerHTML = finalPrice < finalComparePrice
                    ? this.formatMoney(finalComparePrice)
                    : '';
            }
        }


        initEvent() {
            for (const bundle of this.bundles) {
                const checkBox = bundle.querySelector('input[type="checkbox"]');
                const quantityInput = bundle.querySelector('input[data-quantity-variant-id]');
                this.update(checkBox, quantityInput);
                checkBox.addEventListener('change', (e) => {
                    this.update(checkBox, quantityInput);
                });
                quantityInput.addEventListener('change', (e) => {
                    this.update(checkBox, quantityInput);
                });
            }
        }

        formatMoney(cents, format) {
            var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = format || window.theme.moneyFormat || moneyFormat;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                thousands = thousands || ',';
                decimal = decimal || '.';

                if (isNaN(number) || number === null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.');
                var dollarsAmount = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    '$1' + thousands
                );
                var centsAmount = parts[1] ? decimal + parts[1] : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'");
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }
    }

    customElements.define('black-friday-products', BlackFridayProducts);
}


if (!customElements.get('black-friday-products-swiper')) {
    class BlackFridayProductsSwiper extends HTMLElement {
        constructor() {
            super();
            this._swiperInstance = null;
            this.columnsDesktop = Number(this.getAttribute("data-columns-desktop") ?? 2);
            this._swiperContainer = this;
            this.learnInstance = document.querySelector("." + this.dataset.learn)
            this.listInstance = document.querySelector("." + this.dataset.list)
            const elementID = this.dataset.id;
            this.nextButton = this.parentElement.querySelector(`#${elementID} .swiper-btn-next`);
            this.prevButton = this.parentElement.querySelector(`#${elementID} .swiper-btn-prev`);
            const isMobile = `(max-width: 768px)`;
            const isMobileMQL = window.matchMedia(isMobile);

            isMobileMQL.addEventListener('change', (event) => {
                if (!event.matches) {
                    this.createSlider();
                } else if (this._swiperInstance) {
                    this.destroySwiper();
                }
            });
            if (!isMobileMQL.matches) {
                this.createSlider();
                this.initLearnMore();
            }
        }

        initLearnMore() {
            this.learnInstance.addEventListener("click", () => {
                // this.listInstance.classList = this.listInstance.classList + ' active';
                this.destroySwiper();
                this._swiperContainer.classList = this._swiperContainer.classList + ' stop';
                this.learnInstance.parentElement.classList = this.learnInstance.parentElement.classList + ' hide';
                this.nextButton.classList = this.nextButton.classList + ' hide';
                this.prevButton.classList = this.prevButton.classList + ' hide';
            })
        }

        createSlider() {
            const pagination = this.querySelector(`.swiper-pagination`);
            const loop = this.getAttribute('data-loop') === 'true'


            const autoplay = false;
            const autoplaySpeed = 3000;
            const columnsDesktop = 4;




            const swiperConfig = {
                slidesPerView: 1,
                slidesPerGroup: 4,
                spaceBetween: 20,
                direction: "horizontal",
                navigation: {
                    nextEl: this.nextButton,
                    prevEl: this.prevButton,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                breakpoints: {
                    769: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    990: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                }
            };

            if (autoplay) {
                swiperConfig.autoplay = {
                    delay: autoplaySpeed,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                };
            }

            if (loop) {
                swiperConfig.loop = true;
            }

            this._swiperInstance = new Swiper(this._swiperContainer, swiperConfig);
        }

        destroySwiper() {
            if (this._swiperInstance) {
                this._swiperInstance.destroy();
                this._swiperInstance = null;
            }
        }
    }

    customElements.define('black-friday-products-swiper', BlackFridayProductsSwiper);
}